import { render, staticRenderFns } from "./TutorialFormula.vue?vue&type=template&id=746d82a9&scoped=true"
import script from "./TutorialFormula.vue?vue&type=script&lang=js"
export * from "./TutorialFormula.vue?vue&type=script&lang=js"
import style0 from "./TutorialFormula.vue?vue&type=style&index=0&id=746d82a9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746d82a9",
  null
  
)

export default component.exports